import React from 'react';
import proptypes from 'prop-types';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useConfigService } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { PAYPAL_CLIENT_ID, PAYPAL_ENABLE } from '../constants/constants';
import { PaypalMessage } from './PaypalMessage';

const { string, bool } = proptypes;

const PaypalPriceMessaging = (props) => {
  const {
    fontSize,
    fromPage,
    namespace,
    orderTotal,
    payInFour
  } = props;

  const isPaypalEnabled = useConfigService(PAYPAL_ENABLE);
  const paypalClientId = useConfigService(PAYPAL_CLIENT_ID);

  if (!isPaypalEnabled) {
    return false;
  }

  return (
    <div data-component="PaypalCheckoutButton">
      <ErrorBoundary name="paypal-checkout-button-price">
        <PayPalScriptProvider
          options={{
            clientId: paypalClientId,
            commit: 'false',
            components: 'messages',
            dataNamespace: namespace
          }}
        >
          {(payInFour) && (
            <div className="sui-col-span-2" data-testid="paypal-pay-in-four-message">
              <PaypalMessage
                fontSize={fontSize}
                fromPage={fromPage}
                orderTotal={orderTotal}
              />
            </div>
          )}
        </PayPalScriptProvider>
      </ErrorBoundary>
    </div>
  );
};

PaypalPriceMessaging.propTypes = {
  fontSize: string,
  fromPage: string.isRequired,
  namespace: string,
  orderTotal: string.isRequired,
  payInFour: bool
};

PaypalPriceMessaging.defaultProps = {
  fontSize: '12',
  namespace: 'paypalMessageSdk',
  payInFour: false,
};

PaypalPriceMessaging.displayName = 'PaypalPriceMessaging';

export { PaypalPriceMessaging };